jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});

 $(function () {
  $("#vat_no").click(function () {
    if ($(this).is(":checked")) {
      $("#vat_reg_no").hide();
      
    } else {
      $("#vat_reg_no").show();
    }
  });

   $('#vat_reg_no').keyup(function() {

     // If value is not empty
     if ($(this).val().length == 0) {
       // Hide the element
       $('.vat_checkbox').show();
     } else {
       // Otherwise show it
       $('.vat_checkbox').hide();
     }
   }).keyup();
   
});  